// CC-090: exact ServiceTitan bookmark names shown as each upload box title.
export const ST_REPORT_NAMES = {
  st_commission: "Invoice Item Detail with Technician Details",
  st_hours: "PAYROLL: Weekly Technician Hours by Job (BP)",
  st_ar_open: "AR: Open Invoice Detail (Collections)",
  st_splits: "Payroll (Detail) (Legacy Report)",
};

// CC-203: fixed instruction card per box. Required/Optional mirrors what the backend enforces:
// only st_ar_open is enforced (approval refuses without it, payroll.py NO_AR_SNAPSHOT_UPLOADED).
const PAY_WEEK = "The pay week shown at the top of this page (Monday to Sunday).";
const UPLOAD_HOW = "UPLOAD FILE. Export to Excel or CSV, then drop it in the box.";
export const ST_REPORT_CARDS = {
  st_commission: {
    subtitle: "Commission Export: what was sold, by whom",
    dateRange: PAY_WEEK, how: UPLOAD_HOW, required: "Optional.", mode: "upload",
  },
  st_hours: {
    subtitle: "Weekly Tech Hours: hours per tech per job",
    dateRange: PAY_WEEK, how: UPLOAD_HOW, required: "Optional.", mode: "upload",
  },
  st_ar_open: {
    subtitle: "AR: unpaid invoices",
    dateRange: "At least the last 60 days. Do NOT use the pay week.", how: UPLOAD_HOW,
    required: "Required to approve.", mode: "upload",
  },
  st_splits: {
    subtitle: "Payroll (Detail): each tech's payroll detail",
    dateRange: "The pay week shown at the top of this page (Monday to Sunday), all 12 techs.",
    how: "PASTE TEXT. This report has no export button. Open it in ServiceTitan, select and copy everything on screen, paste it into the text field, and click Parse pasted text.",
    required: "Optional.", mode: "paste",
  },
};

// CC-203: browser-side header fingerprints (mirror backend payroll_parsers._SLOT_REQUIRED_HEADERS, CC-089).
const REQUIRED_HEADERS = {
  st_commission: ["Job Number", "Primary Technician", "Item Price"],
  st_hours: ["Name", "Job Number", "Duration (Decimal)"],
  st_ar_open: ["Job #", "Balance", "Invoice #"],
};
export const SPLITS_MARKER = "Payroll Detail Report for";

export const wrongFileMessage = (kind) =>
  `This doesn't look like ${ST_REPORT_NAMES[kind]}. You need the bookmark called ${ST_REPORT_NAMES[kind]}.`;

const csvHeaders = (line) => line.split(",").map((h) => h.trim().replace(/^"|"$/g, "").trim());

// true = matches, false = wrong file, null = can't tell in the browser (.xlsx: the server checks it).
export function textMatchesReport(kind, text) {
  if (kind === "st_splits") return text.includes(SPLITS_MARKER);
  const req = REQUIRED_HEADERS[kind];
  if (!req) return null;
  const firstLine = (text.replace(/^\uFEFF/, "").split(/\r?\n/).find((l) => l.trim()) || "");
  const headers = new Set(csvHeaders(firstLine));
  return req.every((h) => headers.has(h));
}

export async function fileMatchesReport(kind, file) {
  const name = (file?.name || "").toLowerCase();
  if (!name.endsWith(".csv") && !name.endsWith(".txt")) return null;
  const text = await file.slice(0, 65536).text();
  return textMatchesReport(kind, text);
}

// Backend CC-089 slot-header 422 codes -> same wording as the browser check.
export const SLOT_HEADER_CODES = ["missing_required_columns", "slot_mismatch", "missing_marker"];
